module.exports = __webpack_public_path__ + "static/media/notesright.cdb19dba.svg";